import React from 'react';
import OfferBar from '../components/OfferBar';
import Navbar from '../components/Navbar';
import styled from 'styled-components';

const AboutContainer = styled.div`
  margin: 2rem;
  font-family: 'Playfair Display SC', serif;
  color: #800020;
`;

export default function About() {
  return (
    <>
      <OfferBar />
      <Navbar />
      <AboutContainer>
        <h1>About CustomCarats</h1>
        <p>
          We are a bespoke jewellery studio specialized in crafting
          customized diamond rings for engagements, weddings, and more.
          Based in London, we partner with top diamond suppliers to bring
          you the highest quality stones. Our mission is to transform your
          vision into a breathtaking masterpiece.
        </p>
      </AboutContainer>
    </>
  );
}
